import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Icon from 'utils/components/icon';
import InfoTooltip from 'utils/components/info-tooltip';

class BlacklistControls extends Component {
  static propTypes = {
    spotId: PropTypes.string,
    user: PropTypes.object
  };

  static defaultProps = {};

  static displayName = 'BlacklistControls';

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  showTooltipInfo() {
    this.refs.infoTooltip.show();
  }

  hideTooltipInfo() {
    this.refs.infoTooltip.hide();
  }

  @autobind
  removeFromBlacklist() {
    var { user } = this.props;
    this.props.removeUser({ user });
  }

  render() {
    var { user } = this.props;
    var note = user && user.note;
    var username = user && `@${user.username}`;
    if (user && user.id && !user.isRegistered) {
      username += ` (${user.id})`;
    }

    return (
      <div className="teammates-controls">
        {note ? (
          <span
            className="note-wrapper"
            ref="infoTooltipAlign"
            onMouseLeave={this.hideTooltipInfo.bind(this)}
            onMouseEnter={this.showTooltipInfo.bind(this)}
          >
            <InfoTooltip
              ref="infoTooltip"
              alignElement={() => this.refs.infoTooltipAlign}
              direction="top"
            >
              <span className="text">{note}</span>
            </InfoTooltip>
            <Icon className="note-icon" name="note" />
          </span>
        ) : null}
        <span className="note-sepreator" />
        <span className="remove-button" onClick={this.removeFromBlacklist}>
          Remove
        </span>
      </div>
    );
  }
}

export default BlacklistControls;
